export default __webpack_public_path__ + "static/users-7ba66ed1b3defdfa22a0a278a76c9b02.png";